<template>
  <div id="index-page" className="flex flex-col min-h-screen overflow-hidden supports-[overflow:clip]:overflow-clip">
    <x-glow :type="1" />
    <nav-header />
    <main class="grow">
      <app-list class="mt-40" />
    </main>
    <nav-footer />
  </div>
</template>
<script lang="ts">
import * as _enum from "~/enums";
import { useSimpleSeo, DEFAULT_SEO_KEYWORDS } from "#imports";
import AppList from "~/components/local/app/app-list.vue";
import NavHeader from "~/components/local/nav-header.vue";
import NavFooter from "~/components/local/nav-footer.vue";
export default {
  components: {
    AppList,
    NavHeader,
    NavFooter
  },
  setup() {
    useSimpleSeo({
      title: "Incigma - Apps",
      description: "Free online tools for internet tasks.",
      keywords: [...DEFAULT_SEO_KEYWORDS],
      author: "Incigma.com",
      image: _enum.og.default
    });
  }
};
</script>
